<template>
    <div class="cancellation-policy">
      <h1>Política de Cancelaciones</h1>
      <section>
        <h2>Introducción</h2>
        <p>
          La presente Política de Cancelaciones describe las prácticas de Geobizi ("nosotros", "nuestro" o "la Empresa") en relación con la cancelación de servicios y productos adquiridos a través de nuestro sitio web www.geobizi.com ("Sitio").
        </p>
      </section>
      <section>
        <h2>Servicios y Productos</h2>
        <p>
          Geobizi ofrece servicios de talleres, formaciones, rutas y actividades relacionadas con la geología, el medioambiente, la conexión con la naturaleza, el bienestar y la ciencia. Además, diseñamos y vendemos materiales para talleres, juguetes científicos y formaciones.
        </p>
      </section>
      <section>
        <h2>Política de Cancelaciones</h2>
        <p>
          Lamentablemente, no realizamos reembolsos por los servicios y productos adquiridos. Todas las ventas son finales y no se aceptarán cancelaciones una vez realizada la compra.
        </p>
      </section>
      <section>
        <h2>Excepciones</h2>
        <p>
          En casos excepcionales, y a nuestra entera discreción, podemos considerar la posibilidad de ofrecer un crédito o un cambio por un servicio o producto equivalente. Estas decisiones se tomarán caso por caso y no implican ninguna obligación por parte de Geobizi.
        </p>
      </section>
      <section>
        <h2>Contacto</h2>
        <p>
          Si tiene alguna pregunta o necesita más información sobre nuestra Política de Cancelaciones, no dude en ponerse en contacto con nosotros:
        </p>
        <p>
          Teléfono: 677170921<br>
          E-mail: geobizi@hotmail.com
        </p>
      </section>
      <section>
        <h2>Última modificación</h2>
        <p>16/05/2023</p>
      </section>
    </div>
  </template>
  
  <script setup>
  </script>
  
  <style scoped>
  .cancellation-policy {
    padding-top: 7rem;
    max-width: 800px;
    margin: 0 auto;
    padding-left: 2rem;
    padding-right: 2rem;
    padding-bottom: 2rem;
    font-family: Arial, sans-serif;
    color: var(--darkgrey);
    line-height: 1.6;
  }
  
  h1, h2 {
    color: var(--darkgreen);
  }
  </style>
  